export default {"src":"/_next/static/media/MasterCard.f3507d7e.svg","height":180,"width":300,"blurWidth":0,"blurHeight":0};